import React from "react";
import { ButtonGroup, Flex, Heading } from "@chakra-ui/react";
import { Create, Remove, Table } from "./components";

const Medications: React.FC = () => {
  const [selectedKeys, setSelectedKeys] = React.useState<(string | number)[]>(
    []
  );

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Heading as="h3" color="black" fontSize="lg" lineHeight="7">
          Medications patient is currently taking
        </Heading>
        <ButtonGroup spacing={4}>
          <Remove
            selectedKeys={selectedKeys}
            onSuccess={() => setSelectedKeys([])}
          />
          <Create />
        </ButtonGroup>
      </Flex>
      <Table selectedKeys={selectedKeys} onChange={setSelectedKeys} />
    </>
  );
};

export default Medications;
